import { Component, Inject, inject, InjectFlags, Input } from '@angular/core';
import { CvService } from '@bwc/src/app/services/cv.service';
import { AppConfig, CVAddModel } from '@digilize/shared/definitions/src';
import { fileTypes } from '@digilize/shared/definitions/src/lib/interfaces/fileTypes';
import { AuthService } from '@digilize/shared/feature/modules/auth/src';
import { APP_CONFIG } from '@digilize/shared/utils/tokens';

import { WizardService } from '../../../services/wizard.service';
import { SelectYourJobComponent } from '../select-your-job/select-your-job.component';

@Component({
  selector: 'bwc-upload-your-cv',
  templateUrl: './upload-your-cv.component.html',
  styleUrls: ['./upload-your-cv.component.scss'],
})
export class UploadYourCvComponent {
  @Input() openFormLink: string;
  @Input() inviteLink: string;
  @Input() vacancyId: string;
  @Input() source: string;
  wizardService = inject(WizardService, InjectFlags.Optional);

  fileTypes: fileTypes[] = [{ type: 'application/pdf', label: '.pdf' }];

  constructor(
    private cvService: CvService,
    private authService: AuthService,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {}

  handleFileUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    this.getUploadedFile(input.files);
  }

  getUploadedFile(fileList: FileList) {
    if (fileList.length === 0) return;
    const file = fileList[0];
    if (this.fileTypes.some((el) => el.type === file.type)) {
      if (this.wizardService) {
        this.wizardService.uploadedFile = file;
        this.wizardService.uploadedFileName = file.name;
        this.wizardService.uploadError = false;
        this.wizardService.isManualFlow = false;
        this.wizardService.goToNext();
      }
    } else {
      if (this.wizardService) {
        this.wizardService.uploadedFile = null;
        this.wizardService.uploadedFileName = null;
        this.wizardService.uploadError = true;
        this.wizardService.goToNext();
      }
      throw new Error('Not supported file format');
    }
  }

  manualCv() {
    localStorage.removeItem(this.appConfig.localStorageAuthPrefix + 'token');
    localStorage.removeItem(this.appConfig.localStorageAuthPrefix + 'tokenExpiration');
    localStorage.removeItem(this.appConfig.localStorageAuthPrefix + 'refresh_token');
    localStorage.removeItem(this.appConfig.localStorageAuthPrefix + 'refreshTokenExpiration');

    const req: CVAddModel = {};

    if (this.openFormLink) {
      req.open_link_id = this.openFormLink;
    }
    if (this.inviteLink) {
      req.invitation_id = this.inviteLink;
    }
    if (this.vacancyId) {
      req.vacancy_id = this.vacancyId;
    }
    if (this.source) {
      req.source = this.source;
    }

    this.cvService.manualCV(req).subscribe(
      (resp: any) => {
        this.authService.setSession({
          token: resp.anonymous_user_token,
          refresh_token: resp.anonymous_user_refresh_token,
        });
        if (this.wizardService) {
        this.wizardService.isManualFlow = true;
        this.wizardService.goToStepByComponent(SelectYourJobComponent);
      }
      },
      (err) => {
        console.error('Error during getting manual CV');
      }
    );
  }
}
